const imagenes5 = document.querySelectorAll('.galeria5 .contenedor-imagen5');
const ttx = document.getElementById('ttx');
const imagenModal5 = document.getElementById('imagen-modal5');
const rr = document.getElementById('message8');



//document.getElementById("resultado").textContent = document.getElementById("id").outerHTML;

imagenes5.forEach((imagen2) => {
    imagen2.addEventListener('click', () => {
        const ruta2 = imagen2.querySelector('img').src;
        imagenModal5.src = ruta2;
        //console.log(ruta2);
       
        const tei = imagen2.querySelector('i').outerHTML;
        let porcion = tei.slice(3, 15);
     
        ttx.innerText=(porcion);
        rr.innerText=('Info'+ porcion);


    });
 });

